/** Forme d'un dossier de prospection, et clé qui l'indexe. */

/**
 * Les identifiants d'établissement (index dans le GeoJSON) repartent de 0 pour
 * les GMF comme pour les hôpitaux : le type fait donc partie de la clé, sinon
 * le GMF 0 et l'hôpital 0 se confondraient. Même clé primaire composite
 * (kind, establishment_id) qu'en base.
 */
export function recordKey(kind, id) {
  return `${kind}:${id}`
}

/** Dossier vierge : ce que voit l'app pour une entité jamais touchée. */
export function emptyRecord(kind, id, extra = {}) {
  return {
    kind,
    id,
    status: 'prospect',
    pros: null,
    since: null,
    paymentDay: null,
    ...extra,
  }
}

/**
 * true si le dossier porte une annotation. Pilote le cerne gris autour du
 * marqueur.
 *
 * Le statut est délibérément exclu : il est déjà rendu par la couleur du
 * marqueur. L'inclure cernerait tous les clients sans rien apprendre de plus.
 * Le cerne répond à une autre question : « quelqu'un a-t-il documenté cette
 * fiche ? »
 */
export function hasData(record, noteCount = 0) {
  if (noteCount > 0) return true
  if (!record) return false
  return (Number.parseFloat(record.pros) || 0) > 0
}
